import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Landing } from '../Landing';
import { VideoUploader } from '../VideoUploader';
import { SocialMedia } from '../SocialMedia';
import { Schedule } from '../Schedule';
//import { TrendSetters } from '../TrendSetter';
import { UserProfile } from '../UserProfile';
import { Billing } from '../Billing';
import { Admin } from '../Admin';
import { Projects } from '../Projects';
import { WorkflowDetail } from '../Workflows';

import { VideoAnalysis, AnalysisHistory, AnalysisDetails } from '../VideoAnalysis';

function AuthenticatedApp({ userProfile, isAdmin }) {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Landing userProfile={userProfile} isAdmin={isAdmin} />} >
                    <Route path="" element={<Navigate to="Projects" replace />} />
                    <Route path="Projects" element={<Projects />} />
                    {/* The old four-section model (Ideas / Edits / Analysis / Reports)
                        competed with the project flow. Its addresses now land on
                        Projects, where every idea and edit lives inside a project. */}
                    <Route path="Ideation" element={<Navigate to="/Projects" replace />} />
                    <Route path="Analysis" element={<AnalysisHistory />} />
                    <Route path="Analyze" element={<AnalysisHistory />} />
                    <Route path="Editing" element={<Navigate to="/Projects" replace />} />
                    <Route path="Edit" element={<Navigate to="/Projects" replace />} />
                    <Route path="VideoReview" element={<AnalysisHistory />} />
                    {/* The standalone posts list is gone; a project's results
                        live in its own Report step. Old links land on Projects
                        rather than 404ing. */}
                    <Route path="Post" element={<Navigate to="/Projects" replace />} />
                    <Route path="Reports" element={<Navigate to="/Projects" replace />} />
                    <Route path="Measure" element={<Navigate to="/Projects" replace />} />
                    <Route path="VideoUploader" element={<VideoUploader />} />
                    <Route path="VideoUploader/:postId" element={<VideoUploader />} />
                    <Route path="Schedule" element={<Schedule />} />
                    {/* <Route path="TrendSetters" element={<TrendSetters />} /> */}
                    <Route path="SocialMedia" element={<SocialMedia />} />
                    <Route path="Variants" element={<Navigate to="/Projects" replace />} />
                    <Route path="VideoWorkspace" element={<Navigate to="/Projects" replace />} />
                    <Route path="VideoAnalysis" element={<VideoAnalysis />} />
                    <Route path="AnalysisHistory" element={<AnalysisHistory />} />
                    <Route path="AnalysisDetails/:analysisId" element={<AnalysisDetails />} />
                    <Route path="Profile" element={<UserProfile existingProfile={userProfile} />} />
                    <Route path="Billing" element={<Billing />} />
                    <Route path="Workflows" element={<Navigate to="/Projects" replace />} />
                    <Route path="Workflow/:workflowId" element={<WorkflowDetail />} />
                    <Route
                        path="Admin"
                        element={isAdmin ? <Admin /> : <Navigate to="/" replace />}
                    />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export { AuthenticatedApp };